import React from 'react';
import { Text } from '@admitkard/ccl/Text';
import { FlagName, Icon } from '@admitkard/ccl/Icon';
import { Avatar } from '@admitkard/ccl/Avatar';
import { Button } from '@admitkard/ccl/Button';
import { Link } from '@admitkard/ccl/Link';
import { UniversityCardCss } from './UniversityCard.css';

interface UniversityProps {
  name: string;
  rank: number;
  countryName: string;
  city: string;
  logoUrl: string;
  universitySlug: string;
  countrySlug: string;
  allCampus: string[];
}

export class UniversityCard extends React.Component<UniversityProps> {
  render() {
    const { name, rank, countryName, city, logoUrl, universitySlug, countrySlug, allCampus } = this.props;
    const universityLink = universitySlug ? `/university/${universitySlug}` : '';

    return (
      <>
        <div className="univ-card">
          <div className="univ-card-top">
            <Link underline="none" href={universityLink}>
              <Avatar variant="circle" alt={name} size="m" src={logoUrl}></Avatar>
            </Link>
            <div className="univ-details">
              <div className="univ-name-container">
                <Text variant="m" lightness={10}>
                  {name}
                </Text>
                <div className="univ-state-container">
                  {countryName && <Icon name={countrySlug as FlagName} size="large"/>}
                  <div className="margin-left-2">
                    <Text lightness={6} variant="s">
                      {city ? `${city}, ` : ''}
                      {countryName || ''}
                    </Text>
                  </div>
                </div>
                <div>
                  <Text variant="s" lightness={7}>
                    Campus: {allCampus.join(', ')}
                  </Text>
                </div>
              </div>
              <div className='rank-container'>
                {rank && <Icon name='trends' size='small' />}
                <span className='margin-left-2'>
                  <Text variant='s' lightness={7}>
                    {rank ? `Country Rank: #${rank}` : ''}
                  </Text>
                </span>
              </div>
            </div>
          </div>
          <div className="univ-card-bottom">
            <Link underline="none" href={universityLink}>
              <Button size="small" color="primary">
                View Details
              </Button>
            </Link>
          </div>
        </div>
        <style jsx>{UniversityCardCss}</style>
      </>
    );
  }
}
